import { handleErrors, simpleDeleteRequestWithBody, simplePostRequestWithBody } from "../../../shared/src/API/baseAPI";
import { ResizableImageUploader } from "../../../shared/src/components/ImageUploader/resizeable-image-uploader";
import { showAlert } from "../../../shared/src/Util/alerts";
import { getQueryParams, hideModal, showModal } from "../../../shared/src/Util/helper";

let uploader = null;
let id = getQueryParams().id;

export function resizeUploader(width, height) {
    if (uploader) {
        uploader.resize(width, height);
    }
}

export function showImageUploadModal() {
    uploader = new ResizableImageUploader('fileInput', {
        height: 300,
        width: 600,
        quality: 0.8,
        uploadButton: document.getElementById('uploadButton'),
        uploadUrl: '/api/v1/blog/image',
        onCropped: (file) => {
        },
        onFileUploaded: (res) => {
            if (res.error) {
                handleErrors(res.error);
                return;
            }

            hideModal('uploadModal');
            showImageOptionsModal(res.url, res.id);
        }
    });
    showModal('uploadModal');

    document.getElementById('uploadFileInput').classList.remove('hidden');
    document.getElementById('insertLinkBtn').classList.remove('hidden');
    document.getElementById('imageLinkFieldset').classList.remove('hidden');
    document.getElementById('uploadFileError').classList.add('hidden');
}

export function insertFromLink() {
    const input = document.getElementById('imageLinkInput');

    if (input.value == '') {
        showAlert(t('blog.inputLinkPlease'), 'error');
        return;
    }

    hideModal('uploadModal');
    showImageOptionsModal(input.value);
}

function showImageOptionsModal(imageUrl, imageId = null) {
    if (!document.getElementById('imageOptionsModal')) {
        
        document.getElementById('imageSize').addEventListener('change', function() {
            const customContainer = document.getElementById('customSizeContainer');
            if (this.value === 'custom') {
                customContainer.classList.remove('hidden');
            } else {
                customContainer.classList.add('hidden');
            }
        });
    }
    
    const insertButton = document.getElementById('insertImageBtn');
    insertButton.setAttribute('onclick', `App.writer.insertImageFromOptions('${imageUrl}', '${imageId}')`);
    
    document.getElementById('imageAltText').value = '';
    document.getElementById('imageSize').value = '';
    document.getElementById('imageAlignment').value = 'center';
    document.getElementById('imageCaption').value = '';
    document.getElementById('customWidth').value = '';
    document.getElementById('customSizeContainer').classList.add('hidden');
    
    showModal('imageOptionsModal');
}

let usedImages = new Map();

export function insertImageFromOptions(imageUrl, imageId) {
    const altText = document.getElementById('imageAltText').value || t('blog.imageAlt');
    const size = document.getElementById('imageSize').value;
    const alignment = document.getElementById('imageAlignment').value;
    const caption = document.getElementById('imageCaption').value;
    const customWidth = document.getElementById('customWidth').value;
    
    let markdown = '';
    let imageTag = `![${altText}](${imageUrl})`;
    
    if (size === 'custom' && customWidth) {
        imageTag = `![${altText}](${imageUrl}){width=${customWidth}}`;
    } else if (size && size !== 'custom') {
        const sizeMap = {
            'small': '25%',
            'medium': '50%',
            'large': '75%',
            'full': '100%'
        };
        imageTag = `![${altText}](${imageUrl}){width=${sizeMap[size]}}`;
    }
    
    switch (alignment) {
        case 'left':
            markdown = `<div class="text-left">\n${imageTag}\n</div>`;
            break;
        case 'right':
            markdown = `<div class="text-right">\n${imageTag}\n</div>`;
            break;
        case 'float-left':
            markdown = `<div class="float-left mr-4 mb-2 clear-left">\n${imageTag}\n</div>`;
            break;
        case 'float-right':
            markdown = `<div class="float-right ml-4 mb-2 clear-right">\n${imageTag}\n</div>`;
            break;
        default:
            markdown = `<div class="text-center clear-both">\n${imageTag}\n</div>`;
    }
    
    if (caption) {
        const captionAlignment = alignment === 'float-left' || alignment === 'float-right' ? 'text-left' : 'text-center';
        markdown += `\n<p class="text-sm text-gray-600 italic ${captionAlignment} mt-1">${caption}</p>`;
    }
    
    usedImages.set(imageUrl, { id: imageId, url: imageUrl });
    
    insertImageMarkdown(markdown);
    hideModal('imageOptionsModal');
    showAlert(t('blog.imageInserted'), 'success');
    updateImageGallery();
}

function extractImagesFromContent(content) {
    const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
    const images = new Set();
    let match;
    
    while ((match = imageRegex.exec(content)) !== null) {
        images.add(match[2]);
    }
    
    return images;
}

function updateImageGallery() {
    const galleryContainer = document.getElementById('imageGallery');
    if (!galleryContainer) return;

    console.log(window.location.href);

    if (!window.location.href.includes('/blog/editor')) {
        return;
    }
    
    const contentImages = extractImagesFromContent(textarea.value);
    const allImageUrls = new Set([...usedImages.keys(), ...contentImages]);

    if (allImageUrls.size === 0) {
        galleryContainer.innerHTML = '<p class="text-gray-500 text-sm">No images used yet</p>';
        return;
    }
    
    galleryContainer.innerHTML = `
        <div class="flex justify-between items-center mb-3">
            <h3 class="text-sm font-semibold text-gray-700">${t('blog.usedImages')} (${allImageUrls.size})</h3>
            <button id="clearImgBtn" class="btn btn-xs btn-ghost" onclick="App.writer.clearUnusedImages()">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
                ${t('blog.cleanUnused')}
            </button>
        </div>
        <div class="grid grid-cols-4 gap-3 max-h-48 overflow-y-auto">
            ${Array.from(allImageUrls).map(imageUrl => {
                const imageData = usedImages.get(imageUrl);
                const imageId = imageData ? imageData.id : null;
                return `
                    <div class="relative group aspect-square">
                        <img src="${imageUrl}" alt="Used image" class="w-full h-full object-cover rounded border hover:border-primary cursor-pointer transition-all duration-200" onclick="App.writer.insertExistingImage('${imageUrl}', '${imageId}')">
                        <div class="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                            <button class="btn btn-xs btn-circle btn-error shadow-md" onclick="App.writer.removeImage('${imageUrl}', '${imageId}')" title="Delete image">
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                `;
            }).join('')}
        </div>
    `;
}

export function insertExistingImage(imageUrl, imageId) {
    showImageOptionsModal(imageUrl, imageId);
}

export async function removeImage(imageUrl, imageId) {
    if (imageId) {
        simpleDeleteRequestWithBody('/api/v1/blog/image/', { id: imageId}, 'clearImgBtn', (res) => handleImageRemove(res, imageUrl))
        return
    }

    handleImageRemove(null);    
}

function handleImageRemove(res, imageUrl) {
    if (res && res.error) {
        handleErrors(res);
        return;
    }

    usedImages.delete(imageUrl);
    const content = textarea.value;
    const escapedUrl = imageUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    
    const imageRegex = new RegExp(`!\\[([^\\]]*)\\]\\(${escapedUrl}\\)(?:\\{[^}]*\\})?`, 'g');
    const divRegex = new RegExp(`<div[^>]*>\\s*!\\[([^\\]]*)\\]\\(${escapedUrl}\\)(?:\\{[^}]*\\})?\\s*</div>`, 'g');
    const captionRegex = new RegExp(`\\n<p class="text-sm text-gray-600 italic[^"]*">[^<]*</p>`, 'g');
    
    let newContent = content.replace(imageRegex, '');
    newContent = newContent.replace(divRegex, '');
    newContent = newContent.replace(captionRegex, '');
    
    newContent = newContent.replace(/\n\s*\n\s*\n/g, '\n\n');
    newContent = newContent.replace(/<div class="[^"]*clear-[^"]*">\s*<\/div>/g, '');
    
    textarea.value = newContent;
    updatePreview();
    updateImageGallery();
    showAlert(t('blog.imageDeleted'), 'success');
}

export function clearUnusedImages() {
    const contentImages = extractImagesFromContent(textarea.value);
    const removedImages = [];
    
    for (const [url, data] of usedImages) {
        if (!contentImages.has(url)) {
            removedImages.push({ url, id: data.id });
        }
    }
    
    removedImages.forEach(async (image) => {
        if (image.id) {
            simpleDeleteRequestWithBody('/api/v1/blog/image/', { id: image.id}, 'clearImgBtn', (res) => {});
        }
    });
    
    const newUsedImages = new Map();
    for (const url of contentImages) {
        if (usedImages.has(url)) {
            newUsedImages.set(url, usedImages.get(url));
        }
    }
    usedImages = newUsedImages;
    
    updateImageGallery();
    
    if (removedImages.length > 0) {
        showAlert(t('blog.imagesCleared', { count: removedImages.length }), 'info');
    } else {
        showAlert(t('blog.noUnusedImages'), 'info');
    }
}

function initializeImageGallery() {
    const editorContainer = document.getElementById('editor-container') || document.body;
    
    if (document.getElementById('imageGallery')) {
        return;
    };
    if (window.location.href && !window.location.href.includes('/blog/editor')) {
        return;
    }
    
    const galleryHTML = `
        <div class="mt-4 p-4 border rounded-lg bg-base-100">
            <div id="imageGallery">
                <p class="text-gray-500 text-sm">${t('blog.noImagesUsed')}</p>
            </div>
        </div>
    `;
    
    const textarea = document.getElementById('content');
    if (textarea && textarea.parentNode) {
        textarea.parentNode.insertAdjacentHTML('afterend', galleryHTML);
    } else {
        editorContainer.insertAdjacentHTML('beforeend', galleryHTML);
    }
}

const textarea = document.getElementById('content');
const titleInput = document.getElementById('title');
const preview = document.getElementById('preview-content');
const previewTitle = document.getElementById('preview-title');

export function parseCustomMarkdown(content) {
    content = content.replace(/!\[([^\]]*)\]\(([^)]+)\)\{([^}]+)\}/g, (match, alt, url, attributes) => {
        const attrs = attributes.split(',').map(attr => attr.trim());
        let style = '';
        let className = 'max-w-full h-auto';
        
        attrs.forEach(attr => {
            if (attr.startsWith('width=')) {
                const width = attr.substring(6);
                style += `width: ${width};`;
            }
            if (attr.startsWith('height=')) {
                const height = attr.substring(7);
                style += `height: ${height};`;
            }
        });
        
        return `<img src="${url}" alt="${alt}" style="${style}" class="${className}">`;
    });
    
    content = content.replace(/<div class="([^"]*)">\s*!\[([^\]]*)\]\(([^)]+)\)(?:\{([^}]+)\})?\s*<\/div>/g, (match, divClass, alt, url, attributes) => {
        let style = '';
        let className = 'max-w-full h-auto';
        
        if (attributes) {
            const attrs = attributes.split(',').map(attr => attr.trim());
            attrs.forEach(attr => {
                if (attr.startsWith('width=')) {
                    const width = attr.substring(6);
                    style += `width: ${width};`;
                }
                if (attr.startsWith('height=')) {
                    const height = attr.substring(7);
                    style += `height: ${height};`;
                }
            });
        }
        
        return `<div class="${divClass}"><img src="${url}" alt="${alt}" style="${style}" class="${className}"></div>`;
    });
    
    // Parse standard markdown
    let html = '';
    if (typeof marked !== 'undefined') {
        html = marked.parse(content);
    } else {
        html = content
            .replace(/^### (.*$)/gm, '<h3">$1</h3>')
            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>')
            .replace(/`(.*?)`/g, '<code>$1</code>')
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
            .replace(/\n\n/g, '</p><p>')
            .replace(/\n/g, '<br>');
        
        if (html && !html.startsWith('<p>')) {
            html = '<p>' + html + '</p>';
        }
    }
    
    html = html.replace(/<img(?![^>]*class=)/g, '<img class="max-w-full h-auto"');
    html = html.replace(/<h1>/g, '<h1 class="text-5xl">')
        .replace(/<h2>/g, '<h2 class="text-4xl">')
        .replace(/<h3>/g, '<h3 class="text-3xl">')
        .replace(/<h4>/g, '<h4 class="text-2xl">')
        .replace(/<h5>/g, '<h5 class="text-xl">')
        .replace(/<h6>/g, '<h6 class="text-lg">')
        .replace(/<blockquote>/g, '<blockquote class="border-l-4 border-gray-500 pl-4">')
        .replace(/<ul>/g, '<ul class="list-disc list-inside">')
        .replace(/<ol>/g, '<ol class="list-decimal list-inside">')
        .replace(/<li>/g, '<li class="ml-4">')
        .replace(/<ul>/g, '<ul class="list-disc list-inside">')
        .replace(/<ol>/g, '<ol class="list-decimal list-inside">')
        .replace(/<code>/g, '<code class="bg-gray-200 p-1 rounded">')
        .replace(/<a /g, '<a class="link link-primary"');
    
    return html;
}

function updatePreview() {
    if (previewTitle) {
        previewTitle.innerHTML = `<h2 class="text-2xl font-semibold">${titleInput?.value || t('blog.untitledPost')}</h2>`;
    }
    if (!preview) return;
    
    if (!textarea || textarea.value.trim() === '') {
        preview.innerHTML = `<p class="text-gray-500">${t('blog.noContentPreview')}</p>`;
        return;
    }
    
    try {
        preview.innerHTML = parseCustomMarkdown(textarea.value);
    } catch (error) {
        console.error('Markdown parsing error:', error);
        preview.innerHTML = `<p class="text-red-500">${t('blog.errorParsingMarkdown')}</p>`;
    }
    
    updateImageGallery();
}

function insertImageMarkdown(markdown) {
    const textarea = document.getElementById('content');
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    
    const imageMarkdown = `\n\n${markdown}\n\n`;
    
    textarea.value = text.slice(0, start) + imageMarkdown + text.slice(end);
    textarea.focus();
    textarea.setSelectionRange(start + imageMarkdown.length, start + imageMarkdown.length);
    updatePreview();
}

if (typeof marked !== 'undefined') {
    marked.setOptions({
        breaks: true,
        gfm: true,
        headerIds: true,
        headerPrefix: '',
        highlight: null,
        langPrefix: 'hljs language-',
        mangle: true,
        pedantic: false,
        sanitize: false,
        silent: false,
        smartLists: true,
        smartypants: false,
        xhtml: false
    });
}

function addToolbarButtons() {
    let toolbar = document.getElementById('editor-toolbar');
    
    if (!toolbar) {
        const textarea = document.getElementById('content');
        if (textarea) {
            const toolbarHTML = `
                <div id="editor-toolbar" class="mb-4 p-2 rounded border flex flex-wrap gap-2">
                    <!-- Toolbar buttons will be added here -->
                </div>
            `;
            textarea.parentNode.insertAdjacentHTML('beforebegin', toolbarHTML);
            toolbar = document.getElementById('editor-toolbar');
        }
    }
    
    if (!toolbar) return;
    
    const buttons = [
        { text: 'H1', action: () => insertMarkdown('# ', '') },
        { text: 'H2', action: () => insertMarkdown('## ', '') },
        { text: 'H3', action: () => insertMarkdown('### ', '') },
        { text: 'Bold', action: () => insertMarkdown('**', '**') },
        { text: 'Italic', action: () => insertMarkdown('*', '*') },
        { text: 'Code', action: () => insertMarkdown('`', '`') },
        { text: 'Link', action: () => insertMarkdown('[', '](url)') },
        { text: 'Image', action: () => showImageUploadModal() },
        { text: 'Return', action: () => insertMarkdown('<br>', '') },
        { text: 'Divider', action: () => insertMarkdown('<div class="divider">', '</div>') },
    ];
    
    buttons.forEach(button => {
        const btn = document.createElement('button');
        btn.textContent = button.text;
        btn.className = 'btn btn-sm btn-secondary';
        btn.onclick = button.action;
        toolbar.appendChild(btn);
    });
}

function insertMarkdown(before, after) {
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selectedText = text.slice(start, end);
    
    const replacement = before + selectedText + after;
    textarea.value = text.slice(0, start) + replacement + text.slice(end);
    const newCursorPos = start + before.length + selectedText.length;
    textarea.focus();
    textarea.setSelectionRange(newCursorPos, newCursorPos);
    
    updatePreview();
}

const post = {
    title: null,
    text: null,
    excerpt: null,
    author: null,
    published: true,
    comments: false,
    tags: [],
    createdAt: null,
    thumbnailSource: 'auto',
    featuredImage: null
}

export function showThumbnailUploadModal() {
    const thumbnailUploader = new ResizableImageUploader('thumbnailFileInput', {
        height: 400,
        width: 800,
        quality: 0.9,
        uploadButton: document.getElementById('uploadThumbnailButton'),
        uploadUrl: '/api/v1/blog/image',
        onFileUploaded: (res) => {
            if (res.error) {
                handleErrors(res.error);
                return;
            }
            
            post.featuredImage = res.url;
            document.getElementById('thumbnailImg').src = res.url;
            document.getElementById('thumbnailPreview').classList.remove('hidden');
            hideModal('thumbnailUploadModal');
            showAlert(t('blog.thumbnailUploaded'), 'success');
        }
    });
    showModal('thumbnailUploadModal');
}

export function removeThumbnail() {
    post.featuredImage = null;
    document.getElementById('thumbnailPreview').classList.add('hidden');
}

export function submit() {
    post.published = true;
    uploadToServer();
}

function uploadToServer() {
    if (!post.createdAt) {
        post.createdAt = new Date();
    }

    post.text = textarea.value;
    post.title = titleInput.value;
    post.excerpt = document.getElementById('excerpt').value;
    post.comments = document.getElementById('commentsCheck').checked;
    post.thumbnailSource = document.getElementById('thumbnailSource')?.value || 'auto';

    if (post.title == '') {
        showAlert(t('blog.provideTitleError'));
        return;
    }

    if (post.text == '') {
        showAlert(t('blog.enterTextError'))
    }

    const tags = document.getElementById('tags');
    const checkboxes = tags.querySelectorAll('input');
    post.tags = [];
    checkboxes.forEach((box) => {
        if (box.checked) {
            post.tags.push(box.name);
        }
    })

    simplePostRequestWithBody('/api/v1/blog/', { post }, post.published? 'submitBtn' : 'saveBtn', handleUpload);
}

function handleUpload(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    if (res.data.published) {
        showAlert(t('blog.publishSuccess'))
    } else {
        showAlert(t('blog.savedPrivately'))
    }

    setTimeout(() => {
        window.location.href = '/blog/' + res.data.id
    }, 1000);
}

export function save() {
    post.published = false;
    uploadToServer();
}

export function deletePost() {
    simpleDeleteRequestWithBody('/api/v1/blog/', { id }, 'deleteBtn');
}


document.addEventListener('DOMContentLoaded', () => {
    addToolbarButtons();
    initializeImageGallery();
    updatePreview();
    
    const thumbnailSourceSelect = document.getElementById('thumbnailSource');
    if (thumbnailSourceSelect) {
        thumbnailSourceSelect.addEventListener('change', (e) => {
            const manualUpload = document.getElementById('manualThumbnailUpload');
            if (e.target.value === 'manual') {
                manualUpload.classList.remove('hidden');
            } else {
                manualUpload.classList.add('hidden');
            }
        });
    }

    
    if (textarea) {
        textarea.addEventListener('input', updatePreview);
    }
    if (titleInput) {
        titleInput.addEventListener('input', updatePreview);
    }
    
    if (textarea) {
        textarea.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
                e.preventDefault();
                const start = this.selectionStart;
                const end = this.selectionEnd;
                
                this.value = this.value.substring(0, start) + '\t' + this.value.substring(end);
                this.selectionStart = this.selectionEnd = start + 1;
                updatePreview();
            }
        });
    }
});
